import { createLivePreviewRequestHandler } from "src/utils/livePreviewHandler";

/**
 * Live preview request handler for `navbar-items` (collection uses drafts).
 */
export const navbarLivePreviewRequestHandler = createLivePreviewRequestHandler(
  ({ serverURL, apiPath, docId }) =>
    `${serverURL}${apiPath}/navbar-items/${docId}?depth=2&draft=true`
);
